import React from "react";
import { Navbar } from "../generals/Navbar/Navbar";

export const LayoutNavbar = ({ children }) => {
  return (
    <div>
      <Navbar />
      <main className="bg-gray-50 p-16 h-screen">{children}</main>
    </div>
  );
};
